/**
 * Initializes BoldMetrics Event Handlers
 */
function initEvents() {
    document.addEventListener('bmi_add_to_cart', function (e) {
        const size = e.detail.sizeId;
        const [selectSize, selectDimension] = size.includes(' ') ? size.split(' ') : [size, null]; // get size and get dimension if it exists

        if (selectSize) {
            const selectSizeSwatch = document.querySelector('.js-size-swatch[data-attr-value="' + selectSize + '"]');

            if (selectSizeSwatch) {
                // custom event is caught and handled in product/base.js and runs code for selecting a swatch programmatically
                const selectSizeEvent = new CustomEvent('selectAttribute', { detail: selectSizeSwatch });
                document.body.dispatchEvent(selectSizeEvent);
            }
        }

        if (selectDimension) {
            const selectDimensionSwatch = document.querySelector('.js-dimension-swatch[data-attr-value="' + selectDimension + '"]');

            if (selectDimensionSwatch) {
                // waits for size to finish ajax selection process before selecting dimension
                document.body.addEventListener('product:afterAttributeSelect:dtm', function dispatchDimensionEvent() {
                    document.body.removeEventListener('product:afterAttributeSelect:dtm', dispatchDimensionEvent); // remove listener to prevent selection loop
                    // custom event is caught and handled in product/base.js and runs code for selecting a swatch programmatically
                    const selectDimensionEvent = new CustomEvent('selectAttribute', { detail: selectDimensionSwatch });
                    document.body.dispatchEvent(selectDimensionEvent);
                });
            }
        }
    });
}

/**
 * Initializes BoldMetrics Object
 */
function initObject() {
    const boldmetrics = {};
    const dtmProduct = window.digitalData.page.product.productInfo;

    if (dtmProduct) {
        boldmetrics.product = {
            description: dtmProduct.prodDescription,
            id: dtmProduct.prodMfSKU,
            type: dtmProduct.prodCategory,
            price: dtmProduct.prodPrice,
            title: dtmProduct.prodName,
            sizechart: dtmProduct.productSizeChart || ''
        };

        const variantData = window.productCache[boldmetrics.product.id].variantData;

        if (variantData) {
            const variants = [];

            for (const [id, variant] of Object.entries(variantData)) {
                const sizeElement = document.querySelector('.js-size-swatch[data-attr-value="' + variant.size + '"]');
                const dimensionElement = document.querySelector('.js-dimension-swatch[data-attr-value="' + variant.dimension + '"]');

                const displaySize = sizeElement ? sizeElement.getAttribute('data-attr-hover') : '';
                const displayDimension = dimensionElement ? dimensionElement.getAttribute('data-attr-hover') : '';

                variants.push({
                    id: id,
                    sku: id,
                    size: variant.dimension ? variant.size + ' ' + variant.dimension : variant.size,
                    available: !!variant.inventory,
                    additionalMetadata: {
                        displaySize: displayDimension ? displaySize + ' ' + displayDimension : displaySize
                    }
                });
            }

            boldmetrics.product.variants = variants;
        }

        // Update price on swatch interaction
        document.body.addEventListener('product:afterAttributeSelect:dtm', function () {
            const dtmProductPrice = window.digitalData.page.product.productInfo.prodPrice;
            window._boldmetrics.product.price = dtmProductPrice;  // eslint-disable-line no-underscore-dangle
        });
    }

    window._boldmetrics = boldmetrics; // eslint-disable-line no-underscore-dangle
}

initEvents();
initObject();
